import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import logo from "../../../images/logo.png";
import { searchFilter } from "../../features/filter/filterSlice";

export default function Navbar() {
  const auth = useSelector((state) => state.auth);
  const photo = auth?.user?.img;
  const dispatch = useDispatch();
  const debounceHandler = (fn, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  };
  const doSearch = (value) => {
    dispatch(searchFilter(value.toLowerCase()));
  };
  const handleSearch = debounceHandler(doSearch, 500);
  return (
    <div className="flex items-center flex-shrink-0 w-full h-16 px-10 bg-white bg-opacity-75">
      <img src={logo} className="h-10 w-10" alt="logo" />
      <input
        className="flex items-center h-10 px-4 ml-10 text-sm bg-gray-200 rounded-full focus:outline-none focus:ring"
        type="search"
        onChange={(e) => handleSearch(e.target.value)}
        placeholder="Search for anything…"
      />
      <div className="ml-10">
        <Link
          to="/projects"
          className="mx-2 text-sm font-semibold text-indigo-700"
          href="projects.html"
        >
          Projects
        </Link>
        <Link
          to="/teams"
          className="mx-2 text-sm font-semibold text-gray-600 hover:text-indigo-700"
          href="teams.html"
        >
          Team
        </Link>
      </div>
      <button className="flex items-center justify-center w-8 h-8 ml-auto overflow-hidden rounded-full cursor-pointer">
        <img src={photo} alt="user" />
      </button>
    </div>
  );
}
